import PasswordValidator from 'password-validator';

// --- Email validation ---
const EmailSchema = new PasswordValidator();
EmailSchema
  .has(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export const validateEmailString = (validationTarget: string): boolean => EmailSchema
  .validate(validationTarget, { list: false }) as boolean;
